import React from 'react';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

import useLayoutBucket from '../../hooks/useLayoutBucket';
import { drawerGeometry } from '../../components/layout/shellMetrics';
import KvkkRequestDetails from '../../components/kvkk/KvkkRequestDetails';

// KVKK talebinin SALT OKUNUR ayrıntısı (spec §4.2: İK notu tabloda kısaltılır, tam metin
// çekmecede). Neden GenericFormDrawer DEĞİL: bu bir form değil, kaydedilecek bir şey yok
// (WebhookDeliveriesDrawer / BulkJobsDrawer ile aynı gerekçe); kabuk ölçüleri onlarla aynı
// (FE-08, drawerGeometry). Açıklama 2000 karaktere kadar çıkabilir: kaydırma yalnız çekmece
// gövdesindedir (sayfa kaymaz — çekmece katmanın üstünde). Alanların kendisi ortak
// gövdededir (components/kvkk/KvkkRequestDetails) — İK inceleme çekmecesi de onu çizer.

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #E8ECF0;
  flex-shrink: 0;
`;

const Title = styled.h3`
  font-size: ${({ theme }) => theme.metrics.font.size.lg};
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: none;
  color: ${({ theme }) => theme.colors.text.dark.little};
  cursor: pointer;
  &:hover { background: ${({ theme }) => theme.colors.bgColor}; }
`;

const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export default function KvkkRequestDetailDrawer({ request, onClose }) {
  const { t } = useTranslation();
  const geometry = drawerGeometry(useLayoutBucket());
  const open = Boolean(request);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      direction="right"
      size={geometry.size}
      duration={150}
      overlayOpacity={0.2}
      style={{
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '100vw',
        minWidth: geometry.minWidth,
        margin: geometry.margin,
        borderRadius: geometry.borderRadius,
        height: geometry.height,
        boxShadow: '0 8px 32px rgba(0, 66, 66, 0.12)',
      }}
    >
      {open && (
        <>
          <Header>
            <Title>{t(`kvkkRequest.type.${request.type}`)}</Title>
            <CloseBtn
              type="button"
              onClick={onClose}
              aria-label={t('common.close')}
              data-role="kvkk-request-detail-close"
            >
              <X size={20} />
            </CloseBtn>
          </Header>
          <Body data-role="kvkk-request-detail">
            <KvkkRequestDetails request={request} />
          </Body>
        </>
      )}
    </Drawer>
  );
}
